// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1V61m","question":"Question_question__D6HVc","description":"Question_description__QVxC6"};